<div class="spinner flex-row full-width full-height" [class.stroked]="stroked" [class.invalid]="invalid">
  <mat-spinner [diameter]="compact ? 12 : 16" mode="determinate" value="100"></mat-spinner>
  <mat-spinner [diameter]="compact ? 12 : 16" mode="indeterminate"></mat-spinner>
</div>
